import api from '../api/http';

export async function fetchSystemName() {
  try {
    // 优先走公开接口，避免无权限用户请求 /settings 触发 403
    try {
      const r = await api.get('/system-name', { __silent: true });
      const name = r?.data?.name;
      if (name) return name;
    } catch (e) {
      // 若后端尚未更新该接口，则回退到旧逻辑
    }

    const res = await api.get('/settings', { __silent: true });
    if (Array.isArray(res.data)) {
      const nameSetting = res.data.find(s => s.setting_key === 'system_name');
      return nameSetting?.setting_value || '众邦紫铜 安全管理系统';
    }
    return '众邦紫铜 安全管理系统';
  } catch (e) {
    return '众邦紫铜 安全管理系统';
  }
}
